import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  InputAdornment,
  TextField,
  Typography
} from "@material-ui/core";
import PropTypes from "prop-types";
import { Formik } from "formik";
import { creditActivity } from "../../validations/credit";
import SearchDropdown from "../../components/common/SearchDropdown";
import useAccount from "../../hooks/useAccount";
import CustomDialogTitle from "../../components/common/CustomDialogTitle";

const voucherInTypes = [
  { label: "Thu khác", id: 13, value: 13, key: 13 },
  { label: "Thu trả quỹ", id: 14, value: 14, key: 14 },
  { label: "Thu tiền nợ", id: 15, value: 15, key: 15 },
  { label: "Thu tiền ứng", id: 16, value: 16, key: 16 },
  { label: "Thu tiền phạt", id: 17, value: 17, key: 17 },
  { label: "Thu hoa hồng", id: 18, value: 18, key: 18 },
  { label: "Thu tiền vé hoặc văn phòng", id: 19, value: 19, key: 19 },
  { label: "Bán xe", id: 20, value: 20, key: 20 },
  { label: "Thu hồ sơ", id: 21, value: 21, key: 21 },
  { label: "Thu lãi khác", id: 22, value: 22, key: 22 }
];

const Add = ({ open, handleClose }) => {
  const { useCreateCashFlow } = useAccount();

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <CustomDialogTitle
          title="Nhập phiếu thu tiền"
          handleClose={handleClose}
        />
        <Formik
          initialValues={{
            partnerName: "",
            amount: "",
            voucherType: "",
            reason: "",
            type: "in"
          }}
          validationSchema={creditActivity()}
          onSubmit={async (values, actions) => {
            await useCreateCashFlow(values, actions);
            handleClose();
          }}
        >
          {({
            errors,
            handleChange,
            touched,
            isValid,
            isSubmitting,
            values,
            handleSubmit,
            handleBlur,
            setFieldValue
          }) => (
            <>
              <DialogContent>
                <Typography
                  color="textPrimary"
                  variant="h4"
                  sx={{ my: 1, textTransform: "uppercase" }}
                >
                  Nhập phiếu thu tiền
                </Typography>
                <Divider />
                <Grid container spacing={2}>
                  <Grid item sm={12} md={8}>
                    <TextField
                      error={Boolean(touched.partnerName && errors.partnerName)}
                      helperText={touched.partnerName && errors.partnerName}
                      onChange={handleChange}
                      autoFocus
                      size="small"
                      margin="normal"
                      id="partnerName"
                      value={values.partnerName}
                      label="Người Nộp tiền"
                      required
                      type="text"
                      fullWidth
                      variant="outlined"
                    />
                    <TextField
                      error={Boolean(touched.amount && errors.amount)}
                      helperText={touched.amount && errors.amount}
                      onChange={event => {
                        let newValue = event.target.value;
                        newValue =
                          parseInt(newValue.replace(/[^\d\\.]/g, "")) || "";
                        setFieldValue("amount", newValue);
                      }}
                      size="small"
                      margin="normal"
                      id="amount"
                      value={values.amount.toLocaleString("en-US") || 0}
                      label="Số tiền"
                      type="text"
                      fullWidth
                      variant="outlined"
                      required
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">VNĐ</InputAdornment>
                        )
                      }}
                    />
                    <SearchDropdown
                      title="Loại phiếu"
                      data={voucherInTypes || []}
                      error={Boolean(touched.voucherType && errors.voucherType)}
                      helperText={touched.voucherType && errors.voucherType}
                      value={values.voucherType}
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      required
                      id="voucherType"
                    />

                    <TextField
                      error={Boolean(touched.reason && errors.reason)}
                      helperText={touched.reason && errors.reason}
                      onChange={handleChange}
                      size="small"
                      margin="normal"
                      id="reason"
                      value={values.reason}
                      label="Lý do thu tiền"
                      type="text"
                      fullWidth
                      multiline
                      rows={5}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions
                sx={{
                  borderTop: "1px solid rgba(224, 224, 224, 1)"
                }}
                className="justify-start"
              >
                <Grid container spacing={2}>
                  <Grid item sm={12} md={12}>
                    <Button
                      variant="contained"
                      disabled={!isValid || isSubmitting}
                      onClick={handleSubmit}
                      sx={{
                        marginRight: 2,
                        marginLeft: 2
                      }}
                      size="small"
                    >
                      Lưu lại
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={handleClose}
                      size="small"
                    >
                      Đóng
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </>
          )}
        </Formik>
      </Dialog>
    </div>
  );
};
Add.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func
};

export default Add;
